import { makeStyles } from 'tss-react/mui';

export const useRecallSyncProgressStyles = makeStyles()(theme => ({
  wrapper: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
    marginBottom: 16,
    padding: theme.spacing(1.5, 2),
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: 4,
    backgroundColor: theme.palette.background.paper,
  },
  text: {
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
    fontSize: 14,
  },
  title: {
    fontWeight: 700,
  },
  details: {
    color: theme.palette.text.secondary,
  },
  alert: {
    marginBottom: 16,
  },
}));
